(() => {
  const API_URL = "https://app.macroargentina.com.ar/api/cart/efectivo-total";

  function formatMoney(centavos) {
    const pesos = Math.round(centavos / 1000) * 10; // redondeo a la decena, igual que money-no-zeros.liquid
    return "$ " + pesos.toLocaleString("es-AR");
  }

  async function actualizarTotalEfectivo() {
    let cart;
    try {
      cart = await fetch("/cart.js").then((r) => r.json());
    } catch (e) {
      console.error("[cart-efectivo] no se pudo leer /cart.js", e);
      return;
    }

    const wrappers = document.querySelectorAll(".js-cart-total-efectivo");

    if (!cart.items || cart.items.length === 0) {
      wrappers.forEach((el) => (el.style.display = "none"));
      return;
    }

    const items = cart.items.map((item) => ({
      shopify_product_id: item.product_id,
      quantity: item.quantity,
    }));

    let data;
    try {
      const res = await fetch(API_URL, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ items }),
      });
      data = await res.json();
    } catch (e) {
      console.error("[cart-efectivo] error consultando el endpoint de Laravel", e);
      wrappers.forEach((el) => (el.style.display = "none"));
      return;
    }

    const totalCentavos = data.total_efectivo_centavos || 0;

    if (totalCentavos <= 0) {
      wrappers.forEach((el) => (el.style.display = "none"));
      return;
    }

    const formatted = formatMoney(totalCentavos);

    wrappers.forEach((wrapper) => {
      wrapper.style.display = "";
      const moneyEl = wrapper.querySelector(".js-cart-total-efectivo-money");
      if (moneyEl) moneyEl.textContent = formatted;
    });

    // Persistimos el valor CRUDO en centavos (no formateado) como cart
    // attribute: viaja automáticamente al checkout y queda disponible como
    // order.attributes["monto_efectivo_centavos"] en el mail de confirmación
    // (Settings > Notifications). Se guarda en centavos, sin formatear, para
    // poder sumarle el envío real (shipping_price) con aritmética de Liquid
    // recién en el mail -- el costo de envío todavía no existe en este punto
    // del carrito, se define después en el paso de Shipping del checkout.
    try {
      await fetch("/cart/update.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          attributes: { monto_efectivo_centavos: String(totalCentavos) },
        }),
      });
    } catch (e) {
      console.error("[cart-efectivo] no se pudo guardar el cart attribute", e);
    }
  }

  document.addEventListener("DOMContentLoaded", actualizarTotalEfectivo);
  document.addEventListener("cart-change", actualizarTotalEfectivo);
  document.addEventListener("product-added", actualizarTotalEfectivo);
})();